<template>
    <div class="row g-1">
        <div class="mx-2 timezone-picker">
            <fr-select
                v-model="timezone"
                :options="getTimezones"
                optionLabel="label"
                optionValue="value"
                placeholder="Timezone"
                class="w-100"
                scrollHeight="300px"
                filter
                autoFilterFocus
                resetFilterOnHide
                @change="changeTimeZone"
            >
                <template #value="slotProps">
                    <img :src="TimeZoneImg" style="width:40px; border-radius: 30%;">
                    {{ this.zonesGroup.find(e => e.group.includes(slotProps.value))?.short }}
                </template>   
            </fr-select>
        </div>
    </div>
</template>
<script>
import FrSelect from 'primevue/dropdown';
import { rawTimeZones } from "@vvo/tzdb";
import timezone from 'dayjs/plugin/timezone';
import utc from "dayjs/plugin/utc";
import dayjs from "dayjs";
import TimeZoneImg from "../assets/timepicker.png";
import { setTimezone } from '@/apiClient';
import { useTimeZoneStore } from '../stores/timezone';
import { storeToRefs } from "pinia";
import { useBrandsStore } from "../stores/brands"
dayjs.extend(utc)
dayjs.extend(timezone)
    export default {
        setup() {
            const brandStore = useBrandsStore()
            const { selectedBrandId } =storeToRefs(brandStore);
            const timeStore = useTimeZoneStore();
            const { timezone } = storeToRefs(timeStore);
            return {
                storeTimezone: timezone,
                selectedBrandId
            }
        },
        components: {
            FrSelect
        },
        props: {
           
            disabled: {
                type: Boolean,
                default: false,
            },
            labelType : {
                type: String,
                default: 'short'
            },
            size:{
                type: String,
                default: ''
            }
        },
        data() {
            return  {
                timezone: dayjs.tz.guess(),
                TimeZoneImg: TimeZoneImg,
                modelValue: '',
            }
        },
        mounted() {          
            this.timezone = this.storeTimezone || localStorage.getItem(`timeZone-${this.selectedBrandId}`);
        },
        watch: {
            storeTimezone() {
                this.timezone = this.storeTimezone || localStorage.getItem(`timeZone-${this.selectedBrandId}`);
            }
        },
        computed:{
            zonesGroup() {
                return rawTimeZones.map(e => { return  { group :e.group, short: e.abbreviation } });
            },
            getTimezones() {
                return Intl.supportedValuesOf("timeZone").map((tz) => {
                    const tzLongName = new Intl.DateTimeFormat("default", {
                        timeZone: tz,
                        timeZoneName: "longGeneric",
                    }).formatToParts().find(({ type }) => type === "timeZoneName").value;
                    const gmtOffset = new Intl.DateTimeFormat("default", {
                        timeZone: tz,
                        hourCycle: "h23",
                        timeZoneName: "longOffset",
                    }).formatToParts().find(({ type }) => type === "timeZoneName").value;
                    // Parse the GMT offset
                    const offsetParts = gmtOffset.replace("GMT", "").split(":");
                    const hours = parseInt(offsetParts[0]) || 0;
                    const minutes = parseInt(offsetParts[1]) || 0;
                    const offset = hours + minutes / 60;

                    return { gmtOffset, offset, tzLongName, tz };
                    })
                    .sort((a, b) => a.offset - b.offset)
                    .map(({ gmtOffset, tzLongName, tz }) => {
                    return {
                        label: `${gmtOffset} | ${tzLongName} - ${tz.split('/').filter((e, i) => i != 0).join(',').replaceAll('_', ' ')}`,
                        value: tz,
                    };
                });
            }
        },
        methods: {
            changeTimeZone() {
                this.modelValue = this.timezone;
                const key = `timeZone-${this.selectedBrandId}`;
                localStorage.setItem(key, this.timezone);
                setTimezone(this.timezone);
                this.$emit('timezone-changed');
            }
        }
    }
</script>
<style>
 .timezone-picker {
    .p-dropdown-label {
        text-overflow: initial!important;
        color:#f3f5f8;
    }
    .p-dropdown {
        background: none;
        border:none;
        max-width: 85%;
        position: relative;
        left: 10px;
    }
    .p-inputtext {
        color:rgb(243, 245, 245)
    }
    .p-dropdown:not(.p-disabled).p-focus{
        outline:none;
    }
    .p-dropdown .p-dropdown-label.p-placeholder {
        color: #ffffffe5;
    }
    .p-dropdown .p-dropdown-trigger {
        color: #f3f5f8;
    }

    .multiselect__tags {
        min-height: initial!important;
        max-height: initial!important;
        padding: 0.3rem 0.65rem !important;
        height: 35px!important;
        height: 100%;
        font-family: "Source Sans Pro", Helvetica, Arial, sans-serif
    }
}

</style>